import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
import { PreviewScheduleService } from "../../../services/preview-schedule.service";
import { Ng2ConfirmationService } from "../../../services/ng2confirmation.service";
import { ModalService } from "../../../services/modal.service";
import { ChangesItem, StaffPlaygroundActionVM } from "../../../shared/models/previewBalance/playground/changes.model";
import { PreviewBalanceConstants, SaveAction, PlayGroundAction } from "../../../shared/constants/previewBalance.constants";
import { Report } from "../../../shared/models/previewBalance/report.model";


@Component({
    selector: 'app-playground-changes',
    templateUrl: './playgroundChanges.component.html',
    styleUrls: ['./playgroundChanges.component.scss']
})
export class PlaygroundChangesComponent {
    
    @Input() playgroundReport: Report;
    @Input() playgroundChangesIsLoading: boolean;
    @Input() StaffPlaygroundAction: Function;
    changesItemsArray: ChangesItem[] = new Array<ChangesItem>();
    @Output() playgroundApplied: EventEmitter<any> = new EventEmitter();
    dataLoaded: boolean = false;

    constructor(
        private previewSchedule: PreviewScheduleService,
        private modalService: ModalService,
        private confirmation: Ng2ConfirmationService,
    ) { }

    public revertChanges(changesItem?: ChangesItem) {

        let requestObject = new StaffPlaygroundActionVM();
        requestObject.reportId = this.playgroundReport.reportId;

        if (changesItem) {
            requestObject.action = PlayGroundAction.Revert;
            requestObject.facilityCode = changesItem.facilityCode;
            requestObject.roomNumber = changesItem.roomNumber;
            requestObject.staffName = changesItem.staffName;
            requestObject.staffId = changesItem.staffId;
            requestObject.newLimitToRack = changesItem.newLimitToRack;
            requestObject.previousLimitToRack = changesItem.previousLimitToRack;
            requestObject.playgroundChangeId = changesItem.playgroundChangeId;
        } else {
            requestObject.action = PlayGroundAction.RevertAll;
        }

        this.StaffPlaygroundAction(requestObject, changesItem);
    }

    public applyChanges() {
        this.confirmation.YesNoConfirmation('Are you sure you want to apply changes?', { no: 'Cancel', yes: 'Yes'})
            .Yes(() => {
                let requestObject = new StaffPlaygroundActionVM();
                requestObject.reportId = this.playgroundReport.reportId;

                let loading = this.modalService.Loading();

                this.previewSchedule.ApplyStaffPlayground(requestObject).then((result) => {

                    this.load(this.playgroundReport.reportId);
                    this.clearChanges();

                    loading.dismiss();
                    this.modalService.Success(result.data.message);
                    this.playgroundApplied.emit(null);
                });
            })
            .Ask();
    }

    public load(reportId: number) {
        this.dataLoaded = false;
        this.previewSchedule.StaffPlaygroundChanges(reportId).then((result) => {
            this.changesItemsArray = result.data;
            this.dataLoaded = true;
        });
    }

    private clearChanges() {
        this.changesItemsArray = [];
    }
}

